const gatblac = {
  FORMS: [],
  CSS: {
    id: '0',
    name: 'default',
    avatar: {
      name: 'Lara',
      header: 'https://chatbotqa.gatblac.com/static/avatar/gatblac/avatar_header.png',
      new: 'https://chatbotqa.gatblac.com/static/avatar/gatblac/gatblac.gif',
      open: 'https://chatbotqa.gatblac.com/static/avatar/gatblac/chat-open.png',
      close: 'https://chatbotqa.gatblac.com/static/avatar/gatblac/chat-open.png'
    },
    style: {
      score: {
        inactiveStar: '#fff',
        activeStar: '#02afb9',
        borderStar: '#02afb9'
      }
    }
  }
}

export default gatblac
